<script lang="ts">
	import type { CoverImage } from '$lib/features/image/imageDetails.type';
	import { UrlUtil } from '$lib/utils/url.util';
	import { fade } from 'svelte/transition';
	import IconMapMarker from '~icons/mdi/camera';

	const {
		images,
		eagerLoading,
		onHoverChange
	}: { images: CoverImage[]; eagerLoading: boolean; onHoverChange?: (isHovered: boolean) => void } = $props();

	let isHovered = $state<boolean>(false);

	$effect(() => {
		if (onHoverChange) {
			onHoverChange(isHovered);
		}
	});
</script>

<div
	class="absolute inset-0 h-full w-full"
	onmouseenter={() => (isHovered = true)}
	onmouseleave={() => (isHovered = false)}
	role="img"
>
	{#if !isHovered || images.length <= 1}
		{@render ImageCover()}
	{:else}
		{@render ImageGallery()}
	{/if}
</div>

{#snippet ImageCover()}
	{const firstImage = $derived<CoverImage | undefined>(images[0])}
	{#if firstImage}
		<img
			class="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
			src={UrlUtil.getFullImageUrl(firstImage)}
			alt={firstImage.altText}
			loading={eagerLoading ? 'eager' : 'lazy'}
			width={firstImage.width}
			height={firstImage.height}
			decoding="async"
		/>
	{:else}
		<div class="flex h-full w-full flex-col items-center justify-center bg-base-200 p-4 text-center text-base-content/20">
			<IconMapMarker class="text-3xl" />
		</div>
	{/if}
{/snippet}

{#snippet ImageGallery()}
	{const MAX_IMAGES = 4}
	<figure class="absolute inset-0 hover-gallery h-full w-full" in:fade={{ duration: 300 }}>
		{#each images.slice(0, MAX_IMAGES) as image (image.filename)}
			<img
				class="h-full w-full object-cover"
				src={UrlUtil.getFullImageUrl(image)}
				alt={image.altText}
				width={image.width}
				height={image.height}
				decoding="async"
			/>
		{/each}
	</figure>
{/snippet}
